<app-page-layout 
  [title]="title"
  [subtitle]="subtitle"
  [phoneNumber]="phoneNumber"
  [heroImage]="heroImage"
  [breadcrumbs]="breadcrumbs"
  [prevPage]="prevPage"
  [nextPage]="nextPage"
  [partners]="partners">
  
  <div class="content-section">
    <div class="intro-section">
      <h2>Assurance Moto - Scooter - Cyclo - Vespa Personnelle</h2>
      <p>
        Vous êtes un motomobiliste – motard et vous recherchez une assurance moto personnelle, mais vous ne trouvez 
        pas d'assureurs ? <strong>BROKINS vous trouve l'assurance qu'il vous faut au prix le plus juste.</strong>
      </p>
      <p>
        <a href="/contact" class="contact-link">Contactez-nous !</a>
      </p>
      <p>
        Par ailleurs, nous avons de nombreux partenaires spécialisés dans les cas difficiles autrement dit les 
        <strong>RISQUES AGGRAVES !</strong> Malus de <strong class="highlight-purple">3,5</strong>, Stupéfiants, Alcoolémie, Annulation de permis, suspension 
        de permis, sanction judiciaire…
      </p>
    </div>

    <div class="info-section">
      <p>
        Si les 2 roues à assurer ont été achetées sur les fonds de la société, ou si le nom de la société apparaît 
        sur la carte grise de la moto ou du scooter, alors il sera nécessaire de souscrire à une 
        <a routerLink="/assurance-moto-professionnelle" class="professional-link">Assurance Moto Professionnelle</a>.
      </p>
      <p>
        Le courtier en Assurance BROKINS est partenaire de nombreux assureurs, dont un échantillon est affiché ci-dessous : 
        <strong class="text-purple">APRIL, AXA, FMA, NOVELIA SURAVENIR, NETVOX, ZEPHIR, XENASSUR, MUTUELLE DES MOTARDS AMV</strong>
      </p>
    </div>

    <div class="advantages-section">
      <h3>DES AVANTAGES EXCLUSIFS :</h3>
      <ul>
        <li>Larges critères de souscription : résilié compagnie, malussé, suspension ou annulation de permis, nonpaiement, alcoolémie,</li>
        <li>Garantie sécurisation du permis incluse dès la formule de base,</li>
        <li>Assistance <strong class="highlight-purple">0 km</strong> et véhicule de remplacement en option,</li>
        <li>Souscription et carte verte immédiates,</li>
        <li>Règlement mensuel possible y compris pour les non-paiements de prime,</li>
        <li>Réduction automatique de <strong class="highlight-purple">50%</strong> sur la franchise dommage après <strong class="highlight-purple">12 mois</strong> d'assurance sans sinistre responsable,</li>
        <li>Paiement du stage permis,</li>
        <li>Jusqu'à <strong class="highlight-purple">8 000 €</strong> de prise en charge en cas de dommages causés sur les équipements vestimentaires et accessoires hors-série (bottes, combinaison, blouson, pantalon, gilet et pantalon airbag, top-case, valises…),</li>
        <li>Une suspension des garanties : Mauvais temps ? Voyage prolongé ? Arrêt maladie ? Grâce à l'option suspension des garanties vous pouvez suspendre les garanties de circulation lorsque la moto est au garage et ainsi bénéficier d'une réduction de leur prime allant jusqu'à <strong class="highlight-purple">30%</strong>.</li>
      </ul>
    </div>
  </div>
</app-page-layout>
